export default "__VITE_ASSET__Q3$$xltd__"